import { trace } from 'owa-trace';

export function getGlobalFolderViewStateForTelemetry(
    globalFolderViewState: string | null | undefined
): Record<string, unknown> | null | undefined {
    if (globalFolderViewState === undefined) {
        return undefined;
    }
    if (globalFolderViewState === null) {
        return null;
    }

    let value: unknown;
    try {
        value = JSON.parse(globalFolderViewState);
    } catch (error) {
        if (!(error instanceof SyntaxError)) {
            throw error;
        }
        trace.warn('Failed to parse GlobalFolderViewState for session telemetry.', 'analytics');
        return undefined;
    }

    if (value === null) {
        return null;
    }
    if (typeof value !== 'object' || Array.isArray(value)) {
        trace.warn('Unexpected GlobalFolderViewState shape in session telemetry.', 'analytics');
        return undefined;
    }
    const folderViewState = value as Record<string, unknown>;
    delete folderViewState.MailboxFolderExpansionStateV1;
    return folderViewState;
}
